import { render, staticRenderFns } from "./CheckboxOptionSlot.vue?vue&type=template&id=37028e29&shadow"
import script from "./CheckboxOptionSlot.vue?vue&type=script&lang=js&shadow"
export * from "./CheckboxOptionSlot.vue?vue&type=script&lang=js&shadow"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports